import { Fragment, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "./utils/cn";

export interface DlProps extends HTMLAttributes<HTMLDListElement> {
  rows: { label: ReactNode; value: ReactNode }[];
}

export const Dl = ({ rows, className, ...rest }: DlProps) => (
  <dl className={cn("hui-dl", className)} {...rest}>
    {rows.map((r, i) => (
      <Fragment key={i}>
        <dt>{r.label}</dt>
        <dd>{r.value}</dd>
      </Fragment>
    ))}
  </dl>
);
